<template>
  <div class="home-details theme-green">
    <ly-header></ly-header>
    <div class="top">
      <ul class="left"></ul>
      <div class="center">
        <input type="text" placeholder="请输入设备编号" class="number" v-model="number" />
        <input type="button" value="搜索" class="number-btn" @click="HandleClick()" />
        <date-picker v-model="date1" valuetype="format" appendToBody></date-picker>
        <span class="txt">至</span>
        <date-picker v-model="date2" valuetype="format" appendToBody></date-picker>
        <button class="btn-cx" @click="HandleClicks()">查询</button>
      </div>
      <div class="right"></div>
    </div>

    <div class="content">
      <div class="left">
        <div class="left-top">
          <img src="../assets/img/sjtj-title.png" alt />
          <div style="height:60%">
            <device-time></device-time>
          </div>
          <div style="height:40%">
            <device-sbfh></device-sbfh>
          </div>
        </div>
        <div class="left-bottom">
          <img src="../assets/img/sbjkfx-title.png" alt />
          <device-jkfx></device-jkfx>
        </div>
      </div>
      <div class="center">
        <div id="models" class="center-top">
          <div id="model" class="model"></div>
          <div class="model-nav">
            <device-state :stateData="stateData" :bgData="bgData"></device-state>
          </div>
        </div>
        <div class="center-bottom">
          <img src="../assets/img/gzfx-title.png" alt />
          <device-gzfx></device-gzfx>
          <device-tjfx></device-tjfx>
          <device-tjplfx></device-tjplfx>
        </div>
      </div>
      <div class="right">
        <img src="../assets/img/sbwb-title1.png" alt />
        <device-detail :StartTime="date1" :EndTime="date2" ref="child"></device-detail>
        <div class="sbgk">
          <img src="../assets/img/sbgk-title.png" alt />
          <!-- 设备概况 -->
          <div class="sbgklist">
            <div v-for="item of sbgkItem" :key="item.kid">
              <p>
                <span>{{item.title}}</span>
                <span>{{item.nav}}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LyHeader from "./common/Header";

import DeviceJkfx from "./home/echarts6"; //设备健康分析
import DeviceGzfx from "./home/echarts7"; //故障分析
import DeviceTjfx from "./home/echarts8"; //停机时长分析
import DeviceTjplfx from "./home/echarts9"; //停机频率分析
import DeviceSbfh from "./home/echarts10"; //设备负荷
import DeviceSbzt from "./home/echarts11"; //设备运行状态
import DeviceDetail from "../device/DeviceDetailMaintenanceRecord"; //  设备详情
import DeviceTime from "./home/echarts12"; //  早中晚班
import DeviceState from "./home/echarts13"; // 运行状态

import * as THREE from "three";
import { OrbitControls } from "../../xiayan/assets/src/jsm/controls/OrbitControls";
import DatePicker from "vue2-datepicker"; //时间选择

export default {
  name: "HomeDetails",
  data() {
    let todayTime = new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000; //今天0点时间戳秒
    return {
      date1: this.$formatDateTime(todayTime, "yyyy-MM-dd"),
      date2: this.$formatDateTime(todayTime + 3600 * 24, "yyyy-MM-dd"),
      demo: "",
      camera: null, //相机
      scene: null, //场景
      renderer: null, //渲染器
      ambientLight: null, //环境光
      pointlight: null, //点光源
      controls: null, //控制器

      showModel: null, //模型
      number: null, //编号
      Plane: null, //平面
      LTJ: null, // 链条机
      GTJ: null, //滚筒机
      DSYJGT: null, //顶升移载滚筒
      DSYZLT: null, //顶升移载链条
      MPJ: null, //码盘机
      JBJ: null, //夹抱机
      CDJ: null, //  拆垛机
      TSJ: null, //提升机
      DDJ: null, //堆垛机

      modelType: "提升机",
      stateData: [
        { name: "设备名称", value: "1004", details: "提升机" },
        { name: "所属订单", value: "JFKDSFDK1004" },
        { name: "任务编号", value: "13004" }
      ],
      bgData: [
        { name: "电压", value: "380" },
        { name: "电流", value: "220" },
        { name: "核心温度", value: "380" },
        { name: "核心转速", value: "139" }
      ],
      model: {
        //  模型序号
        LTJ: [
          "1008",
          "1009",
          "1010",
          "1014",
          "1016",
          "1017",
          "1021",
          "1023",
          "1024",
          "1025",
          "1027",
          "1028",
          "1029",
          "1031",
          "1033",
          "1034",
          "1035",
          "1037",
          "1038",
          "1039",
          "1042",
          "1043",
          "1044",
          "1046",
          "1047",
          "1048",
          "1050",
          "1051",
          "1053",
          "1054",
          "1056",
          "1057",
          "1060",
          "1061",
          "1063",
          "1064",
          "1066",
          "1069",
          "1070",
          "1072"
        ],
        GTJ: [
          "1001",
          "1003",
          "1005",
          "1012",
          "1013",
          "1019",
          "1026",
          "1036",
          "1045",
          "1058",
          "1068",
          "1073",
          "1075",
          "1076",
          "1078",
          "1079",
          "1080",
          "1082",
          "1083",
          "1084",
          "1085",
          "1086",
          "1087",
          "1088",
          "1089",
          "1091",
          "1092",
          "1093",
          "1094",
          "1095",
          "1096",
          "1097",
          "1098",
          "1099",
          "1100",
          "1102",
          "1103",
          "1104",
          "1105",
          "1106",
          "1107",
          "1108",
          "1110",
          "1111",
          "1112",
          "1114",
          "1115",
          "1116",
          "1118",
          "1119"
        ],
        DSYJGT: [
          "1006",
          "1007",
          "1011",
          "1015",
          "1018",
          "1020",
          "1022",
          "1030",
          "1032",
          "1040",
          "1041",
          "1049",
          "1052",
          "1055",
          "1059",
          "1062",
          "1067",
          "1071"
        ],
        DSYZLT: ["1081", "1090", "1101"],
        MPJ: ["1065"],
        JBJ: ["1004", "1074"],
        CDJ: ["1002"],
        TSJ: ["1077", "1109", "1113", "1117"],
        DDJ: ["9001", "9002", "9003"]
      },
      sbgkItem: [],
      sbgkList: [
        {
          title: "厂商",
          nav: "今天国际",
          kid: 1
        },
        {
          title: "上线时间",
          nav: "2015/06/27",
          kid: 2
        },
        {
          title: "规格型号",
          nav: "CSC160L",
          kid: 3
        },
        {
          title: "车体质量",
          nav: "750kg",
          kid: 4
        },
        {
          title: "最大载重",
          nav: "1000kg",
          kid: 5
        },
        {
          title: "移载方式",
          nav: "链条",
          kid: 6
        },
        {
          title: "移载定位方式",
          nav: "广电",
          kid: 7
          
        }
      ]
    };
  },
  components: {
    LyHeader,
    DatePicker,
    DeviceJkfx,
    DeviceGzfx,
    DeviceTjfx,
    DeviceTjplfx,
    DeviceSbfh,
    DeviceSbzt,
    DeviceDetail,
    DeviceTime,
    DeviceState
  },
  mounted() {
    this.init();
    this.animate();
    this.MenuGetData();
  },
  methods: {
    MenuGetData() {
      let _this = this;
      let len = this.sbgkList.length;
      if (len < 9) {
        _this.sbgkItem = _this.sbgkList;
        let _index = 9 - len;
        for (var i = 0; i < _index; i++) {
          let text = {
            title: "厂商",
            nav: "今天国际",
            kid: len + i + 1
          };
          _this.sbgkItem.push(text);
        }
      }
    },
    HandleClicks() {
      this.$refs.child.getItemList();
      console.log(this.date1);
      console.log(this.date2);
    },
    HandleClick() {
      var _this = this;
      var KidNumber = _this.number;
      for (var key in this.model) {
        if (this.model[key].indexOf(KidNumber) > -1) {
          this.HideModel(this.showModel); //全部隐藏
          this.ShowModel(this.Plane); //显示平面
          this.stateData[0].value = this.number;
          if (key == "LTJ") {
            this.ShowModel(this.LTJ); //链条机
            this.stateData[0].details = "链条机";
          } else if (key == "GTJ") {
            this.ShowModel(this.GTJ); //滚筒机
            this.stateData[0].details = "滚筒机";
          } else if (key == "DSYJGT") {
            this.ShowModel(this.DSYJGT); //顶升移载滚筒
            this.stateData[0].details = "顶升移载滚筒";
          } else if (key == "MPJ") {
            this.ShowModel(this.MPJ); //码盘机
            this.stateData[0].details = "码盘机";
          } else if (key == "JBJ") {
            this.ShowModel(this.GTJ); //夹抱机
            this.stateData[0].details = "夹抱机";
          } else if (key == "CDJ") {
            this.ShowModel(this.CDJ); //拆垛机
            this.stateData[0].details = "拆垛机";
          } else if (key == "TSJ") {
            this.ShowModel(this.TSJ); //提升机
            this.stateData[0].details = "提升机";
          } else if (key == "DDJ") {
            this.ShowModel(this.DDJ); //堆垛机
            this.stateData[0].details = "堆垛机";
          } else if (key == "DSYZLT") {
            this.ShowModel(this.DSYZLT); //顶升移载链条
            this.stateData[0].details = "顶升移载链条";
          }
        }
      }
    },
    init() {
      //场景
      this.scene = new THREE.Scene();
      this.scene.background = new THREE.Color(0x358a6d); //场景的背景
      var content = document.getElementById("model");
      // 相机
      this.camera = new THREE.PerspectiveCamera(
        50,
        600 / 455,
        0.01,
        10000000.0
      );
      this.camera.position.set(0.88, 28.5, 57.67);
      this.camera.lookAt(0, 200, 0);

      //
      this.renderer = new THREE.WebGLRenderer({
        antialias: true
      });
      this.renderer.shadowMap.enabled = true;
      this.renderer.setClearColor(new THREE.Color(0xeeeeee));
      this.renderer.setSize(600, 455);
      document.getElementById("model").appendChild(this.renderer.domElement);

      // 光
      this.ambientLight = new THREE.AmbientLight(0xd7efff);
      this.ambientLight.position.set(0, 0, 0);
      this.ambientLight.intensity = 1;

      this.pointlight = new THREE.PointLight(0xffffff);
      this.pointlight.position.set(-36.815, 80.716, 97.64);
      this.pointlight.intensity = 0.8;
      this.pointlight.castShadow = true;
      this.pointlight.shadow.mapSize.width = 4096; //阴影质量
      this.pointlight.shadow.mapSize.height = 4096;

      this.scene.add(this.pointlight);
      this.scene.add(this.ambientLight);

      this.object = new THREE.Object3D();
      this.scene.add(this.object);

      // 控制器
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);
      this.controls.enableRotate = true;
      this.controls.screenSpacePanning = false;
      this.controls.minDistance = 1;
      this.controls.maxDistance = 130;
      this.controls.maxPolarAngle = Math.PI / 2.01;

      // 加载模型
      this.addScene("model");

      // 监听窗口
      window.addEventListener("resize", this.onWindowResize, false);
      // 单击
      window.addEventListener("click", this.MouseClick, false);
    },
    addScene(name) {
      var _this = this;
      var objectLoader = new THREE.ObjectLoader();
      objectLoader.load(
        "../../../../static/model/" + name + ".json",
        obj => {
          obj.scale.set(5, 5, 5);
          obj.position.set(0, -10, 0);
          this.showModel = obj;
          this.scene.add(obj);

          this.LTJ = this.scene.getObjectByName("LTJ");
          this.GTJ = this.scene.getObjectByName("GTJ");
          this.DSYJGT = this.scene.getObjectByName("DSYJGT");
          this.DSYZLT = this.scene.getObjectByName("DSYZLT");
          this.MPJ = this.scene.getObjectByName("MPJ");
          this.JBJ = this.scene.getObjectByName("JBJ");
          this.CDJ = this.scene.getObjectByName("CDJ");
          this.TSJ = this.scene.getObjectByName("TSJ");
          this.DDJ = this.scene.getObjectByName("DDJ");

          this.Plane = this.scene.getObjectByName("Floor_001");

          this.HideModel(this.showModel); //全部隐藏
          this.ShowModel(this.TSJ); //默认展示提升机
          this.ShowModel(this.Plane); //显示平面
        },
        this.onProgress,
        this.onError
      );
    },
    onProgress() {
      //加载过程中
    },
    onError() {
      //加载失败
    },
    onWindowResize() {
      this.camera.aspect = 600 / 455;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(600, 455);
    },
    // 隐藏模型
    HideModel(model) {
      if (model.children.length > 0) {
        model.traverse(function(obj) {
          if (obj.type === "Mesh") {
            obj.visible = false;
          }
        });
      } else {
        model.visible = false;
      }
    },
    ShowModel(model) {
      if (model.children.length > 0) {
        model.traverse(function(obj) {
          if (obj.type === "Mesh") {
            obj.visible = true;
          }
        });
      } else {
        model.visible = true;
      }
    },
    animate() {
      //动画函数
      var _this = this;
      requestAnimationFrame(this.animate);
      if (this.showModel != null) {
        _this.showModel.rotation.y += 0.01;
      }
      this.controls.update();
      this.renderer.render(this.scene, this.camera);
    }
  }
};
</script>


<style scoped>
.home-details {
  width: 1918px;
  height: 853px;
  margin: 0 auto;
      overflow: hidden;
  position: relative;
  background-color: #348975;
}
.top {
  margin-top: 113px;
  padding: 0 30px;
  height: 40px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  background-color: #fff;
}
.left {
  display: flex;
  justify-content: start;
  flex-direction: row;
}
.left li {
  margin-left: 12px;
}
.right .btn {
  width: 130px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
  border-radius: 8px;
  color: #fff;
  background-color: #2eb58a;
}
.btn-cx {
  width: 80px;
  height: 34px;
  line-height: 34px;
  color: #fff;
  border: none;
  outline: none;
  cursor: pointer;
  background-color: #2eb58a;
}
.number {
  height: 34px;
  width: 210px;
  padding: 0 30px;
  border: 1px solid #ccc;
  box-sizing: border-box;
}
.number-btn {
  width: 80px;
  height: 34px;
  line-height: 34px;
  color: #fff;
  border: none;
  outline: none;
  cursor: pointer;
  background-color: #2eb58a;
  margin-right: 80px;
}

/* 内容部分 */
.content {
  padding: 10px 10px;
  height: calc(100% - 174px);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.content > div {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.content .left {
  width: 597px;
}
.content .left-top {
  height: 455px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
}
.content .left-top > img {
  position: absolute;
  top: 0;
  left: 0;
  height: 40px;
}
.left-bottom {
  height: calc(100% - 465px);
  background-color: #fff;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.left-bottom > img {
  position: absolute;
  top: 0;
  left: 0;
  height: 40px;
}
.content .center {
  width: 920px;
}
.content .right {
  width: 363px;
  position: relative;
}
.content .right > img {
  width: 363px;
  position: absolute;
  top: 10px;
  left: 0;
  width: 82%;
  z-index: 2;
}
.center-top {
  height: 455px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}
.model {
  width: 600px;
}
.model-nav {
  width: 320px;
  background-color: #fff;
}
.center-bottom {
  height: calc(100% - 465px);
  background: #fff;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  position: relative;
  align-items: center;
}

.center-bottom > img {
  position: absolute;
  top: 0;
  left: 0;
  height: 40px;
}
.sbgk {
  height: calc(100% - 465px);
  width: 100%;
  background-color: #fff;
  position: relative;
}
.sbgk > img {
  position: absolute;
  top: 0;
  left: 0;
  height: 40px;
}
.sbgklist {
  height: calc(100% - 40px);
  width: 100%;
  position: absolute;
  top: 40px;
  left: 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.sbgklist > div {
  display: flex;
  align-items: center;
  width: 33.33%;
  height: 33.33%;
}
.sbgklist > div > p {
  width: 100px;
  font-size: 14px;
  padding: 2px 0;
  margin: 0 auto;
  text-align: center;
  color: #07805b;
  background-color: #d1f0e5;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>




// WEBPACK FOOTER //
// src/components/xiayan/home/HomeDetails.vue